import { baseApi } from "../baseApi";

export const customerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getcustomer: builder.mutation({
      query: (search_input) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_customer_list1`,
        method: 'POST',
        body: search_input,
      }),
    }),

    getCustomerDetails: builder.mutation({
      query: (customerData) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_customer_details`,
        method: 'POST',
        body: customerData,
      }),
    }),
  }),
});

export const { useGetcustomerMutation, useGetCustomerDetailsMutation } = customerApi;
